<div class="contact-container">
    <div class="contact-header">
        <span class="contact-title">{{ 'footer.contactUs' | translate }}</span>
    </div>
    <div class="contact-body">
        <div class="event-card">
            <p>{{ 'Home.contactusp1' | translate }}</p>
            <p>{{ 'Home.contactusp2a' | translate }} <a class="mailTo" href="mailto:service@pharmacists.ca">{{ 'Home.contactusMailto' | translate }}</a> {{ 'Home.contactusp2b' | translate }}</p>
            <a class="button center" target="_blank" [href]="'Home.contactUsURL' | translate" >{{ 'Home.contactusEmail' | translate }}</a>
        </div>
    </div>
  </div>
  